"use client";
import { useEffect, useState, useRef, useCallback } from "react";

export default function DualRangeSlider({ min, max, minVal, maxVal, onChange }) {
  const [minPrice, setMinPrice] = useState(minVal);
  const [maxPrice, setMaxPrice] = useState(maxVal);
  
  const minValRef = useRef(minVal);
  const maxValRef = useRef(maxVal);
  const rangeRef = useRef(null);

  // Convert to percentage for the colored track fill
  const getPercent = useCallback(
    (value) => Math.round(((value - min) / (max - min)) * 100),
    [min, max]
  );

  // Sync external filter reset changes down to internal slider state
  useEffect(() => {
    setMinPrice(minVal);
    minValRef.current = minVal;
  }, [minVal]);

  useEffect(() => {
    setMaxPrice(maxVal);
    maxValRef.current = maxVal;
  }, [maxVal]);

  // Dynamically update the orange bar highlight fill between thumbs
  useEffect(() => {
    if (rangeRef.current) {
      const minPercent = getPercent(minPrice);
      const maxPercent = getPercent(maxPrice);

      rangeRef.current.style.left = `${minPercent}%`;
      rangeRef.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [minPrice, maxPrice, getPercent]);

  const handleMinChange = (e) => {
    const value = Math.min(Number(e.target.value), maxPrice - 1);
    setMinPrice(value);
    minValRef.current = value;
    onChange({ min: value, max: maxPrice });
  };

  const handleMaxChange = (e) => {
    const value = Math.max(Number(e.target.value), minPrice + 1);
    setMaxPrice(value);
    maxValRef.current = value;
    onChange({ min: minPrice, max: value });
  };

  return (
    <div style={{ 
      position: "relative", 
      width: "100%", 
      height: 24, 
      display: "flex", 
      alignItems: "center",
      marginTop: 4,
      marginBottom: 4
    }}>
      {/* Native range inputs stacked clean directly over each other */}
      <input
        type="range"
        min={min}
        max={max}
        value={minPrice}
        onChange={handleMinChange}
        style={{
          position: "absolute",
          width: "100%",
          height: 0,
          outline: "none",
          pointerEvents: "none",
          zIndex: minPrice > max - 100 ? "5" : "3",
          WebkitAppearance: "none",
        }}
      />
      <input
        type="range"
        min={min}
        max={max}
        value={maxPrice}
        onChange={handleMaxChange}
        style={{
          position: "absolute",
          width: "100%",
          height: 0,
          outline: "none",
          pointerEvents: "none",
          zIndex: "4",
          WebkitAppearance: "none",
        }}
      />

      {/* Styled track backgrounds */}
      <div style={{ position: "relative", width: "100%", height: 6, borderRadius: 999, background: "#fef08a" }}>
        {/* Active Fill Track (Orange highlight bar between selections) */}
        <div
          ref={rangeRef}
          style={{
            position: "absolute",
            height: "100%",
            background: "linear-gradient(90deg, #f97316, #ea580c)",
            borderRadius: 999,
          }}
        />
      </div>
    </div>
  );
}